// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * @file AuthBroadcast.js
 * @description Canal global BroadcastChannel para sincronizar logout entre pestañas.
 */

const CHANNEL_NAME = "archat-auth-channel";

let channel = null;

export function getAuthChannel() {
  if (!channel && typeof BroadcastChannel !== "undefined") {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }
  return channel;
}

export function broadcastLogout() {
  const ch = getAuthChannel();
  if (ch) {
    ch.postMessage({ type: "logout" });
  }
}

export function listenLogout(callback) {
  const ch = getAuthChannel();
  if (!ch) return;
  ch.onmessage = (event) => {
    if (event?.data?.type === "logout") {
      callback();
    }
  };
}

export function closeAuthChannel() {
  if (channel) {
    channel.close();
    channel = null;
  }
}
